import React, { Component } from 'react'
import './styles.css'

class NotFound extends Component {
	render() {
		return (
			<div className='notFound'>
				<h1>404 Error | Page Not Found!!</h1>
			</div>
		)
	}
}

export default NotFound
